import {coreApi} from './core'

export const driverService = {
    getAll: async () => coreApi.get(`driver`),
    getById: async (id) => coreApi.get(`driver?id=${id}`),
    create: async (data) => coreApi.post(`driver`, data),
    update: async (data) => coreApi.put(`driver`, data),
    fromVehicleId: async (vehicleId) => coreApi.get(`driver/vehicle/${vehicleId}`)
}